import { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from 'yup';

import { toast } from "react-toastify";
import { Card, Col, Form, Row, Spinner } from "react-bootstrap"
import ReactInputMask from "react-input-mask";
import { ActionCard } from "../action-card";
import Error from "../../../../../../components/Error";
import { formatCnpj } from "../../../../../../../helpers";

//services
import { saveCompanyDetails, saveCompanyAddress, addCompanyToUser } from "../../../../../../services/profile.service";

const validationSchema = Yup.object({
    socialReason: Yup.string().trim().required("Este campo é obrigatório"),
    fantasyName: Yup.string().trim().required("Este campo é obrigatório"),
    cnpj: Yup.string().trim().required("Este campo é obrigatório"),
    cep: Yup.string().trim().required("Este campo é obrigatório"),
    address: Yup.string().trim().required("Este campo é obrigatório"),
    number: Yup.string().trim().required("Este campo é obrigatório"),
    district: Yup.string().trim().required("Este campo é obrigatório"),
    city: Yup.string().trim().required("Este campo é obrigatório"),
    state: Yup.string().trim().required("Este campo é obrigatório"),
}).required();


export const CardCompanyDetail = (props: any): JSX.Element => {
    const { company, getUser, user } = props;
    const { t: translation } = useTranslation();

    const [loading, setLoading] = useState(false);
    const [updateCompany, setUpdateCompany] = useState(false);

    const { register, handleSubmit, control, formState: { errors } } = useForm({ resolver: yupResolver(validationSchema) });
   
    const onSubmit = (formData: any) => {
        setLoading(true)
        let objCompanyAddress = {
            public_space: formData.address,
            cep: parseInt(formData.cep.replace("-","")),
            number: formData.number,
            district: formData.district,
            city: formData.city,
            state: formData.state
        }

        if (company && Object.keys(company.address).length !== 0) {
            let objCompany = {
                cnpj: formData.cnpj,
                fantasy: formData.fantasyName,
                name: formData.socialReason,
            }            

            saveCompanyDetails(objCompany, company.id).then(() => {
                saveCompanyAddress(objCompanyAddress, company.address.id).then(() => {
                    toast.success("Dados da empresa alterados com sucesso!");
                    setUpdateCompany(false);
                    getUser();
                    setLoading(false);
                }).catch((err) => {
                    toast.error('Ocorreu um erro ao editar os dados da empresa');
                    setLoading(false)
                })
            }).catch((err) => {
                toast.error(err.response.data[0]);
            })

        } else if (company && Object.keys(company.address).length === 0) {
            saveCompanyAddress(objCompanyAddress).then((response) => {
                let objUpdateAddressCompany = {
                    cnpj: formData.cnpj,
                    fantasy: formData.fantasyName,
                    name: formData.socialReason,
                    address: response.id
                }

                saveCompanyDetails(objUpdateAddressCompany, company.id).then(() => {
                    toast.success("Dados da empresa alterados com sucesso!");
                    setUpdateCompany(false);
                    getUser();
                    setLoading(false);
                }).catch((err) => {
                    toast.error(err.response.data[0]);
                })
            })

        } else {
            saveCompanyAddress(objCompanyAddress).then((response) => {
                let objNewCompany = {
                    cnpj: formData.cnpj,
                    fantasy: formData.fantasyName,
                    name: formData.socialReason,
                    address: response.id
                }

                saveCompanyDetails(objNewCompany).then((res) => {
                    let userCompany = {
                        id: user.id,
                        name: user.name,
                        company: res.id,
                        phone: user.phone,
                        email: user.email,
                    }
                    
                    addCompanyToUser(user.id, userCompany).then(() =>{
                        toast.success("Dados da empresa alterados com sucesso!");
                        setUpdateCompany(false);
                        getUser();
                        setLoading(false);
                    }).catch((err) => {
                        toast.error('Ocorreu um erro ao editar os dados da empresa');
                        setLoading(false)
                    })
                }).catch((err) => {
                    toast.error(err.response.data[0]);
                    setLoading(false)
                })
            }).catch((err) => {
                toast.error(err.response.data[0]);
                setLoading(false)
            })
        }
    }  

    return (
        <Card className="account-card mb-4">
            <Form onSubmit={handleSubmit(onSubmit)}>
                <Card.Body>
                    <Card.Title className="ml-5 mr-5 mb-0">
                        <Row>
                            <Col sm={6} className="d-flex align-items-center">
                                <h4 className="mb-0" style={{ fontSize: '22px' }}>{translation('userAccount.companyLabel')}</h4>
                            </Col>
                            <Col sm={6} className="text-end">
                                {
                                    loading ? (
                                        <Spinner animation="border" variant="primary" style={{ width: '2rem', height: '2rem', borderWidth: '0.25em', borderRightColor: 'transparent' }}/>
                                    ) : (
                                        <ActionCard message={translation('userAccount.updateCompany')} show={updateCompany} setChange={setUpdateCompany}></ActionCard>
                                    )
                                }
                            </Col>
                        </Row>
                    </Card.Title>
                    <hr />
                    <Row className="py-3">
                        <Col md={12} className="d-flex align-items-center ml-5 mr-5">
                            <Row className="col-12">
                                <Col xs={12} className="mb-2">
                                    <Row>
                                        <Col md={9} lg={6}>
                                            {
                                                updateCompany ? (
                                                    <Form.Group className="mb-2">
                                                        <Form.Label className="text-darker-grey">{translation('userAccount.company.name')}:</Form.Label>
                                                        <Form.Control type="text" placeholder={translation('userAccount.company.name')} defaultValue={company && company.name ? company.name : ""} {...register("socialReason", { required: true })} />
                                                        {errors.socialReason ? (<div className="w-100"> <Error>{errors.socialReason?.message}</Error> </div>) : ""}
                                                    </Form.Group>
                                                ) : (
                                                    <h6>
                                                        <span className="text-darker-grey">{translation('userAccount.company.name')}: </span>
                                                        {company && company.name ? company.name : "Não informado"}
                                                    </h6>
                                                )
                                            }
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={12} className="mb-2">
                                    <Row>
                                        <Col md={9} lg={6}>
                                            {
                                                updateCompany ? (
                                                    <Form.Group className="mb-2">
                                                        <Form.Label className="text-darker-grey">{translation('userAccount.company.fantasy')}:</Form.Label>
                                                        <Form.Control type="text" placeholder={translation('userAccount.company.fantasy')} defaultValue={company && company.fantasy ? company.fantasy : ""} {...register("fantasyName", { required: true })} />
                                                        {errors.fantasyName ? (<div className="w-100"> <Error>{errors.fantasyName?.message}</Error> </div>) : ""}
                                                    </Form.Group>
                                                ) : (
                                                    <h6>
                                                        <span className="text-darker-grey">{translation('userAccount.company.fantasy')}: </span>
                                                        {company && company.fantasy ? company.fantasy : "Não informado"}
                                                    </h6>
                                                )
                                            }
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={12} className="mb-2">
                                    <Row>
                                        <Col md={9} lg={6}>
                                            {
                                                updateCompany ? (
                                                    <Controller
                                                        name="cnpj"
                                                        control={control}
                                                        rules={{ required: true }}
                                                        defaultValue={company && company.cnpj ? formatCnpj(company.cnpj) : ""}
                                                        render={({ field }) => (
                                                        <ReactInputMask mask="99.999.999/9999-99" 
                                                            value={field.value}
                                                            onChange={field.onChange}
                                                        >
                                                            {(inputProps: any) => (
                                                                <Form.Group className="mb-2">
                                                                    <Form.Label className="text-darker-grey">{translation('userAccount.company.cnpj')}:</Form.Label>
                                                                    <Form.Control type="text" {...inputProps} placeholder={translation('userAccount.company.cnpj')} {...register("cnpj", { required: true })} />
                                                                    {errors.cnpj ? (<div className="w-100"> <Error>{errors.cnpj?.message}</Error> </div>) : ""}
                                                                </Form.Group>
                                                            )}
                                                        </ReactInputMask>
                                                        )}
                                                    />
                                                    
                                                ) : (
                                                    <h6>
                                                        <span className="text-darker-grey">{translation('userAccount.company.cnpj')}: </span>
                                                        {company && company.cnpj ? formatCnpj(company.cnpj) : "Não informado"}
                                                    </h6>
                                                )
                                            }
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={12} className="mb-2">
                                    <Row>
                                        <Col md={9} lg={6}>
                                            {
                                                updateCompany ? (
                                                    <Form.Group className="mb-2">
                                                        <Row className="mb-2">
                                                            <Col md={3}>
                                                                <Controller
                                                                    name="cep"
                                                                    control={control}
                                                                    rules={{ required: true }}
                                                                    defaultValue={company && company.address && company.address?.cep ? company.address?.cep : ""}
                                                                    render={({ field }) => (
                                                                    <ReactInputMask mask="99999-999" 
                                                                        value={field.value}
                                                                        onChange={field.onChange}
                                                                    >
                                                                        {(inputProps: any) => (
                                                                            <Form.Group className="mb-2">
                                                                                <Form.Label className="text-darker-grey">{translation('userAccount.company.cep')}:</Form.Label>
                                                                                <Form.Control type="text" {...inputProps} placeholder={translation('userAccount.company.cep')} {...register("cep", { required: true })} />
                                                                                {errors.cep ? (<div className="w-100"> <Error>{errors.cep?.message}</Error> </div>) : ""}
                                                                            </Form.Group>
                                                                        )}
                                                                    </ReactInputMask>
                                                                    )}
                                                                />
                                                            </Col>
                                                            <Col>
                                                                <Form.Label className="text-darker-grey">{translation('userAccount.company.place')}:</Form.Label>
                                                                <Form.Control type="text" placeholder={translation('userAccount.company.place')} defaultValue={company && company.address && company.address.public_space ? company.address.public_space : ""} {...register("address", { required: true })} />
                                                                {errors.address ? (<div className="w-100"> <Error>{errors.address?.message}</Error> </div>) : ""}
                                                            </Col>
                                                        </Row>
                                                        <Row className="mb-2">
                                                            <Col md={3}>
                                                                <Form.Label className="text-darker-grey">{translation('userAccount.company.number')}:</Form.Label>
                                                                <Form.Control type="text" placeholder="Número" defaultValue={company && company.address && company.address.number ? company.address.number : ""} {...register("number", { required: true })} />
                                                                {errors.number ? (<div className="w-100"> <Error>{errors.number?.message}</Error> </div>) : ""}
                                                            </Col>
                                                            <Col>
                                                                <Form.Label className="text-darker-grey">{translation('userAccount.company.district')}:</Form.Label>
                                                                <Form.Control type="text" placeholder="Bairro" defaultValue={company && company.address && company.address.district ? company.address.district : ""} {...register("district", { required: true })} />
                                                                {errors.district ? (<div className="w-100"> <Error>{errors.district?.message}</Error> </div>) : ""}
                                                            </Col>
                                                        </Row>
                                                        <Row className="mb-2">
                                                            <Col>
                                                                <Form.Label className="text-darker-grey">{translation('userAccount.company.city')}:</Form.Label>
                                                                <Form.Control type="text" placeholder="Cidade" defaultValue={company && company.address && company.address.city ? company.address.city : ""} {...register("city", { required: true })} />
                                                                {errors.city ? (<div className="w-100"> <Error>{errors.city?.message}</Error> </div>) : ""}
                                                            </Col>
                                                            <Col md={3}>
                                                                <Form.Label className="text-darker-grey">{translation('userAccount.company.state')}:</Form.Label>
                                                                <Form.Control type="text" placeholder="Estado" defaultValue={company && company.address && company.address.state ? company.address.state : ""} {...register("state", { required: true })} />
                                                                {errors.state ? (<div className="w-100"> <Error>{errors.state?.message}</Error> </div>) : ""}
                                                            </Col>
                                                        </Row>
                                                    </Form.Group>
                                                ) : (
                                                    <h6>
                                                        <span className="text-darker-grey">{translation('userAccount.company.address')}: </span>
                                                        {
                                                            company && company.address && company.address.public_space && company.address.number && company.address.district && company.address.city && company.address.state ? (
                                                                `${company.address.public_space}, ${company.address.number}, ${company.address.district} - ${company.address.city}-${company.address.state}`
                                                            ) : "Não informado"
                                                        }
                                                    </h6>
                                                )
                                            }
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Card.Body>
            </Form>
        </Card>
    )
}